import LinkWidget from '../LinkWidget';

import { PathFindingLinkFactory, PathFindingLinkModel } from '@projectstorm/react-diagrams';
import _ from 'lodash';
import * as Path from 'paths-js/path';

export default class LinkFactory extends PathFindingLinkFactory {
  constructor() {
    super();
  }

  generateModel = () => new PathFindingLinkModel({
		width: "1px",
		color: "black",
		selectedColor: "#2387da"
	});

	generateReactWidget(event) {
		return (
      <LinkWidget 
          diagramEngine={this.engine} 
          factory={this}
          link={event.model} 
      />
    )
	}

  getCanvasMatrix() {
    if(!this.engine?.getCanvas()) {
      this.canvasMatrix = []
      this.routingMatrix = []
      return []
    }
    return super.getCanvasMatrix()
  }

  calculateRoutingMatrix() {
    if(!this.engine?.getCanvas()) {
      this.canvasMatrix = []
      this.routingMatrix = []
      return
    }
    super.calculateRoutingMatrix()
  }

	generateDynamicPath(pathCoords, sourcePoint, targetPoint) {
		let path = Path();
    const firstX = pathCoords[0][0] * this.ROUTING_SCALING_FACTOR,
          firstY = pathCoords[0][1] * this.ROUTING_SCALING_FACTOR,
          lastX = pathCoords[pathCoords.length - 1][0] * this.ROUTING_SCALING_FACTOR,
          lastY = pathCoords[pathCoords.length - 1][1] * this.ROUTING_SCALING_FACTOR,
          newFirstX = sourcePoint.position.x + 10,
          newFirstY = sourcePoint.position.y,
          newLastX = targetPoint.position.x,
          newLastY = targetPoint.position.y
		path = path.moveto(sourcePoint.position.x, sourcePoint.position.y);
		path = path.lineto(sourcePoint.position.x + 10, sourcePoint.position.y);
		pathCoords.slice(1).forEach(coords => {
      const calculatedX = coords[0] * this.ROUTING_SCALING_FACTOR
      let xToMove = calculatedX
      if(calculatedX === firstX) {
        xToMove = newFirstX
      } else if(calculatedX === lastX) {
        xToMove = newLastX
      }
      const calculatedY = coords[1] * this.ROUTING_SCALING_FACTOR
      let yToMove = calculatedY
      if(calculatedY === firstY) {
        yToMove = newFirstY
      } else if(calculatedY === lastY) {
        yToMove = newLastY
      }
      path = path.lineto(xToMove, yToMove);
		});
		return path.print();
	}

  calculateMatrixDimensions = () => {
		const allNodesCoords = _.values(this.engine.getModel().getNodes()).map(item => ({
			x: item.getX(),
			width: item.width,
			y: item.getY(),
			height: item.height
		}));

		const allLinks = _.values(this.engine.getModel().getLinks());
		const allPortsCoords = _.flatMap(allLinks.map(link => [link.getSourcePort(), link.getTargetPort()]))
			.filter(port => port !== null)
			.map(item => ({
				x: item.getX(),
				width: item.width,
				y: item.getY(),
				height: item.height
			}));
		const allPointsCoords = _.flatMap(allLinks.map(link => link.getPoints())).map(item => ({
			// points don't have width/height, so let's just use 0
			x: item.getX(),
			width: 0,
			y: item.getY(),
			height: 0
		}));

		const concatedCoords = _.concat(allNodesCoords, allPortsCoords, allPointsCoords);
		const minX = Math.floor(Math.min(_.get(_.minBy(concatedCoords, 'x'), 'x', 0), 0) / this.ROUTING_SCALING_FACTOR) * this.ROUTING_SCALING_FACTOR;
		const maxX = Math.floor(Math.max(_.get(_.maxBy(concatedCoords, 'x'), 'x', 0), 0) / this.ROUTING_SCALING_FACTOR) * this.ROUTING_SCALING_FACTOR;
		const minYCoords = _.minBy(concatedCoords, 'y');
		const maxYCoords = _.maxBy(concatedCoords, 'y');
		const minY = Math.floor(Math.min(_.get(minYCoords, 'y', 0), 0) / this.ROUTING_SCALING_FACTOR) * this.ROUTING_SCALING_FACTOR;
		const maxY = Math.floor(Math.max(_.get(maxYCoords, 'y', 0), 0) / this.ROUTING_SCALING_FACTOR) * this.ROUTING_SCALING_FACTOR;
		return {
			width: maxX - minX,
			hAdjustmentFactor: Math.abs(minX) / this.ROUTING_SCALING_FACTOR + 1,
			height: maxY - minY,
			vAdjustmentFactor: Math.abs(minY) / this.ROUTING_SCALING_FACTOR + 1
		};
	};

}
